

    /**
     * Iterates over a callback a set amount of times
     */
    function times(n, callback, thisObj){
        var i = -1;
        while (++i < n) {
            if ( callback.call(thisObj, i) === false ) {
                break;
            }
        }
    }

    module.exports = times;





//////////////////
// WEBPACK FOOTER
// ./~/mout/function/times.js
// module id = 1596
// module chunks = 0 1 2